import { Fragment, useState, useEffect, ReactElement, useRef } from 'react';
import { Keyboard, KeyboardInfo, KeyboardResize, KeyboardResizeOptions } from '@capacitor/keyboard';
import { isPlatform } from '@ionic/react';

//classes
class Position {
    public x: number | null = null;
    public y: number | null = null;
}

const nosntate = {
    swipeCancelTreshold: 0.3 //between 0 - 1
}

interface Props {
    SetKeyboardHeight: any
}

const KeyboardController: React.FC<Props> = ({ SetKeyboardHeight }) => {
    //states
    const [initialTouchPos, SetInitialTouchPos] = useState<Position | null>(null);
    //refs
    const contentScrollViewRef = useRef<any>(null);
    const initialTouchPosRef = useRef<Position | null>(null);
    const touchStartActionRef = useRef<any>((event: any) => {
        if (event.touches.length > 0) {
            initialTouchPosRef.current = { x: event.touches[0].clientX, y: event.touches[0].clientY } as Position;
        }
    });
    const touchMoveActionRef = useRef<any>((event: any) => {
        if (
            event.touches.length > 0
            && initialTouchPosRef.current != null
            && initialTouchPosRef.current.x != null
        ) {
            const amplitude = Math.abs(event.touches[0].clientX - initialTouchPosRef.current.x);
            if (amplitude > nosntate.swipeCancelTreshold) {
                const inputs = Array.from(document.querySelectorAll('input, textarea, select, button'));
                inputs.map((input: any) => {
                    input.blur();
                });
            }
            initialTouchPosRef.current = null;
            SetInitialTouchPos(initialTouchPosRef.current);
        }
    });

    // const blurAllInputsRef = useRef<any>(() => {
    //     console.log('is scrolled!');
    //     const inputs = Array.from(document.querySelectorAll('input, textarea, select, button'));
    //     inputs.map((input: any) => {
    //         input.blur();
    //     });
    // });


    //watchers
    useEffect(() => {
        if (isPlatform('hybrid')) {
            //works for ios only, disables resizes
            Keyboard.setResizeMode({ 'mode': KeyboardResize.None } as KeyboardResizeOptions);

            //in android, add these to manifest file
            //  >> android:windowSoftInputMode="adjustPan", inside  <activity ...> tag

            /** SETTINGS */
            //edit IonApp tag:: className={'App ' + (keyboardHeight > 0 ? 'keyboard' : '')} style={{ height: `calc(100vh - ${keyboardHeight}px)` }} in App.tsx
            //add style={{ width: 'auto', height: 'auto', overflowX: 'hidden', overflowY:'auto' }} to App.tsx IonRouterOutlet component
            //add .App.keyboard { overflow-y: scroll !important; (or without !important) } to App.scss
            //all pages(parent container) should use absolute position instead of fix, or else scrolling not working in ios

            //keyboard listeners
            Keyboard.addListener('keyboardWillShow', (info: KeyboardInfo) => {
                SetKeyboardHeight(info.keyboardHeight);
                //on scroll, hide keyboard - preparations
                if (contentScrollViewRef.current == null)
                    contentScrollViewRef.current = document.getElementsByClassName('IonRouterOutlet')[0];
                // contentScrollViewRef.current.removeEventListener('scroll', blurAllInputsRef.current);

                //auto scroll to focused element
                setTimeout(() => {
                    const focusedElement = document.activeElement;
                    focusedElement?.scrollIntoView({ behavior: 'auto', block: 'center' });

                    //on scrolling unselect all ui fileds
                    setTimeout(() => {
                        console.log('scrollListenerSet!');
                        // contentScrollViewRef.current.addEventListener('scroll', blurAllInputsRef.current);

                        //clear previous implemented listeners
                        document.removeEventListener('touchstart', touchStartActionRef.current);
                        document.removeEventListener('touchmove', touchMoveActionRef.current);

                        document.addEventListener('touchstart', touchStartActionRef.current);
                        document.addEventListener('touchmove', touchMoveActionRef.current);
                    }, 500);
                }, 250);
            });

            Keyboard.addListener('keyboardWillHide', () => {
                setTimeout(() => {
                    SetKeyboardHeight(0);
                    requestAnimationFrame(() => {
                        contentScrollViewRef.current.scrollTo({top: 0});
                    });
                }, 250);
            });
        }

        return (() => {
            if (isPlatform('hybrid')) {
                document.removeEventListener('touchstart', touchStartActionRef.current);
                document.removeEventListener('touchmove', touchMoveActionRef.current);
            }
        });
    }, []);

    //watch for initialTouchpos state updateRef
    useEffect(() => {
        console.log('initialPosUpdated: ' + JSON.stringify(initialTouchPos));
        initialTouchPosRef.current = initialTouchPos;
    }, [initialTouchPos]);

    return (
        <Fragment></Fragment>
    )
}
export default KeyboardController;